// Readable messages for a failed PUT customer/settings. The server's own message can be a raw
// 500 ("Internal Server Error...") or a code-level refusal, so customers never see it as is.

export const CHARGE_AFTER_NOT_ALLOWED_MESSAGE = 'Your account can\'t pay after the job yet. Choose to pay before the job to book.';
export const CHARGE_TYPE_SAVE_FAILED_MESSAGE = 'We couldn\'t save when you want to pay, so your booking wasn\'t sent. Please try again.';
export const CONTACT_DETAILS_NOT_SAVED_MESSAGE = 'Your booking went through, but we couldn\'t save your contact details. You can update them in Contact Info.';
export const SETTINGS_NOT_SAVED_MESSAGE = 'We couldn\'t save your changes. Please try again.';

// The server refuses a switch to paying after the job with this message (400).
const CHARGE_AFTER_REFUSAL = 'not allowed to change to charge after';

export function isChargeAfterRefusal(error: any): boolean {
  const message = error?.message ?? error?.error?.message ?? '';
  return typeof message === 'string' && message.includes(CHARGE_AFTER_REFUSAL);
}

export function chargeTypeSaveErrorMessage(error: any): string {
  return isChargeAfterRefusal(error) ? CHARGE_AFTER_NOT_ALLOWED_MESSAGE : CHARGE_TYPE_SAVE_FAILED_MESSAGE;
}
